import { Categorie } from "../Categorie";
import { ResultsGen } from "./ResultsGen";

export class GroupResultsGen {
   code;
   categorie: Categorie;
   note: number;
   list_note: [];
   note_total:any;
   is_calc: boolean;
   results: ResultsGen[];
  public constructor(code, cat:Categorie, res: ResultsGen[], note, note_total, list_note){
    this.results = res;
    this.code = code ;
    this.categorie  = cat;
    this.is_calc = cat.is_calc;
    this.note = note;
    this.note_total = note_total;
    this.list_note = list_note
  }
}
